module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0012.jpg?v=b0e8ea9d";